import { render, staticRenderFns } from "./AlertFreeAccount.vue?vue&type=template&id=7f3d574a&scoped=true&"
import script from "./AlertFreeAccount.vue?vue&type=script&lang=js&"
export * from "./AlertFreeAccount.vue?vue&type=script&lang=js&"
import style0 from "./AlertFreeAccount.vue?vue&type=style&index=0&id=7f3d574a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3d574a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
